const SPECIAL_ATTR_VALUE_UNQUOTED_CHARS = /(?:^$|%20|[\x00\x20\x09-\x0d\s"'`=<>&])/g;
const NEED_ANTISENSEALL_CHARS = /&(?:amp|#9|#10|#11|#12|#13|#32|#36|#61|lt|gt|quot|#39|#96);|[\x20]/g;
const escapeAll = function(m) {
  return m === "&" ? "&amp;" : m === "	" ? "&#9;" : m === "\n" ? "&#10;" : m === "\v" ? "&#11;" : m === "\f" ? "&#12;" : m === "\r" ? "&#13;" : m === " " ? "&#32;" : m === "=" ? "&#61;" : m === "<" ? "&lt;" : m === ">" ? "&gt;" : m === '"' ? "&quot;" : m === "'" ? "&#39;" : m === "`" ? "&#96;" : m === "%20" ? " " : (
    /*empty or null*/
    ""
  );
};
const unescapeAll = function(m) {
  return m === "&amp;" ? "&" : m === "&#9;" ? "	" : m === "&#10;" ? "\n" : m === "&#11;" ? "\v" : m === "&#12;" ? "\f" : m === "&#13;" ? "\r" : m === "&#32;" ? " " : m === "&#61;" ? "=" : m === "&lt;" ? "<" : m === "&gt;" ? ">" : m === "&quot;" ? '"' : m === "&#39;" ? "'" : m === "&#96;" ? "`" : m === " " ? "%20" : (
    /*empty or null*/
    ""
  );
};
function dangerLinkValue(value) {
  if (!(value.startsWith("https://") || value.startsWith("http://") || value.startsWith("mailto:") || value.startsWith("tel:") || value.startsWith("data:image/") || value.startsWith("ftp://") || value.startsWith("./") || value.startsWith("../") || value.startsWith("#") || value.startsWith("/"))) {
    return true;
  } else {
    return false;
  }
}
function escapeHTML(s) {
  return s.replace(SPECIAL_ATTR_VALUE_UNQUOTED_CHARS, function(m) {
    return escapeAll(m);
  });
}
function unescapeHTML(s) {
  return s.replace(NEED_ANTISENSEALL_CHARS, function(m) {
    return unescapeAll(m);
  });
}
function escapeHTMLHerfAttr(s) {
  const str = s.replace(SPECIAL_ATTR_VALUE_UNQUOTED_CHARS, function(m) {
    return escapeAll(m);
  });
  const newstr = str.trim();
  if (newstr === "#") return "#";
  if (dangerLinkValue(newstr)) {
    return "";
  } else {
    return newstr;
  }
}
export {
  escapeHTML,
  escapeHTMLHerfAttr,
  unescapeHTML
};
//# sourceMappingURL=XssFilter.js.map
